import React from "react";
import Hero from "../Landing/components/Hero/Hero";
import Features from "../Landing/components/Features/Features";
import Solutions from "../Landing/components/Solutions/Solutions";
import Platform from "../Landing/components/Platform/Platform";
import ProcessSection from "../Landing/components/Process/Process";
import TestimonialSection from "../Landing/components/TestimonialSection/TestimonialSection";
import HexagonSection from "../Landing/components/HexagonSection/HexagonSection";
import StatsSection from "../Landing/components/StatsSection/StatsSection";
import FAQ from "../Landing/components/FAQ/FAQ";
import BottomHero from "../Landing/components/BottomHero/BottomHero";
import FeaturedCompanies from "../Landing/components/FeaturedCompanies/FeaturedCompanies";
import Footer from "../Landing/components/Footer/Footer";
import Navbar from "./components/Navbar/Navbar";
import EbenchPlatform from "./components/Solutions/EbenchPlatform";

const NewLandingPage = () => {
  return (
    <div>
      <Navbar />
      <Hero />
      <Features />
      <Solutions />
      <EbenchPlatform/>
      <Platform />
      <ProcessSection />
      <TestimonialSection />
      <HexagonSection />
      <StatsSection />
      <FAQ />
      <BottomHero />
      <FeaturedCompanies />
      <Footer />
    </div>
  );
};

export default NewLandingPage;
